import { z } from "zod";

/**
 * A ShowGenre reference as stored on a movie (`ShowGenreRefDbDto`): just an id
 * and a display name. On update the repository flattens these to `genreIds`.
 */
export const showGenreNestedSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type ShowGenreNestedType = z.infer<typeof showGenreNestedSchema>;

/**
 * A single cast/crew entry (`MovieCastDbDto`). A member is either *linked* to a
 * Person (has `personId`) or *unknown* (free-text `name`) — never both. The
 * backend rejects entries that set both or neither. `name`/`photo` are kept for
 * linked members purely for display; the repository re-derives them server-side.
 */
export const movieCastNestedSchema = z.object({
  personId: z.string().nullish(),
  name: z.string().nullish(),
  characterName: z.string().nullish(),
  department: z.string().default("Acting"),
  photo: z
    .object({
      url: z.string(),
      blurhash: z.string(),
    })
    .nullish(),
});

export type MovieCastNestedType = z.infer<typeof movieCastNestedSchema>;
